import PropTypes from "prop-types";

import TextEllipsis from "@/components/Elements/TextEllipsis";

const DescriptionListItem = ({ label, labelEllipsis, id, content }) => {
  return (
    <>
      <dt id={id}>
        {labelEllipsis ? <TextEllipsis>{label}</TextEllipsis> : label}
      </dt>
      <dd aria-labelledby={id}>{content}</dd>
    </>
  );
};

DescriptionListItem.propTypes = {
  label: PropTypes.string.isRequired,
  labelEllipsis: PropTypes.bool,
  id: PropTypes.string,
  content: PropTypes.node,
};

export default DescriptionListItem;
